export default "__VITE_ASSET__DBMrUrzj__"